import { useMemo } from 'react';

const MAX_SYMBOLS_LENGTH = 53;
const SEPARATOR = ', ';

interface SliceResult {
    stringItems: string;
    collapsedCount: number;
    isOverflow: boolean;
}

const useSliceRowItems = (filledStrLength: number, items: Array<string>): SliceResult =>
    useMemo(
        () =>
            items.reduce<{ data: SliceResult; done: boolean }>(
                (result, item, index) => {
                    if (result.done) {
                        result.data.collapsedCount += 1;
                    } else {
                        const string = result.data.stringItems ? `${result.data.stringItems}${SEPARATOR}${item}` : item;

                        if (string.length <= MAX_SYMBOLS_LENGTH - filledStrLength) {
                            result.data.stringItems = string;
                        } else {
                            result.data.collapsedCount += 1;
                            result.done = true;
                        }
                    }

                    if (items.length === index + 1 && !result.data.stringItems) {
                        result.data.collapsedCount -= 1;
                        result.data.stringItems = items[0];
                        result.data.isOverflow = true;
                    }

                    return result;
                },
                { data: { stringItems: '', isOverflow: false, collapsedCount: 0 }, done: false }
            ).data,
        [items, filledStrLength]
    );

export default useSliceRowItems;
